var React = require('react');

function IcArrowBackInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16,8.646l-.757.818L8.541,2.22V19.044H7.459V2.22L.757,9.464,0,8.646,8,0Z","transform":"translate(0 16) rotate(-90)","fill":"#fff"}));
}

IcArrowBackInline.defaultProps = {"width":"19.044","height":"16","viewBox":"0 0 19.044 16"};

module.exports = IcArrowBackInline;

IcArrowBackInline.default = IcArrowBackInline;
